import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import { Box, breakpoints, Caption, P, ResponsiveImage } from 'ui/acro'

const CoachCard = forwardRef(
  ({ alt, name, thumbnails, tagline, slug }, ref) => {
    const imagesArray = [
      {
        src: thumbnails.desktop,
        breakpoint: breakpoints[1]
      }
    ]

    return (
      <Box
        ref={ref}
        as='a'
        href={`/instructors/${slug}`}
        id={`home-instructor-card-${slug}`}
        aria-label={`Find classes from ${slug}`}
        className='swiper-slide unstyled'
        maxWidth={['145px', null, '240px']}
      >
        <ResponsiveImage
          src={thumbnails.mobile}
          alt={alt}
          imagesArray={imagesArray}
        />
        <Caption variant='heavy' color='grey6' mt={['16px']}>
          {name}
        </Caption>
        <P color='grey6' mt={['4px', '9px']}>
          {tagline}
        </P>
      </Box>
    )
  }
)

CoachCard.propTypes = {
  alt: PropTypes.string,
  name: PropTypes.string,
  thumbnails: PropTypes.shape({
    mobile: PropTypes.string,
    desktop: PropTypes.string
  }),
  tagline: PropTypes.string,
  url: PropTypes.string
}

export default CoachCard
